define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/def/Field",
    "csi/form/Widget",
    "csi/xml"
], function(declare,lang,Field,Widget,xml) {
    return declare(Widget, {
        FIELD_PRINT_POSITIONS_COUNT: "PrintPositionsCount",
        
        _resolveView: function() {
            if (!this.defView.getField(this.FIELD_PRINT_POSITIONS_COUNT)) {
                this.defView.addField(lang.mixin(new Field(), {
                    m_id: this.FIELD_PRINT_POSITIONS_COUNT,
                    m_bRequired: true,
                    m_path: "Child:CurrentRevision",
                    m_type: xml.ATTR_INTEGER,
                    widgetParams: {constraints: {min: 1, max: 100}}
                }));
                this.addDefaultValue(this.FIELD_PRINT_POSITIONS_COUNT, 1);
            } 
            this.inherited(arguments);
        }
    });
});